// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OverviewCard_wrapper__GnPHN","extradetails":"OverviewCard_extradetails__1EBkA"};